import { createApp } from 'vue/dist/vue.esm-bundler.js'


import App from './App'
const el = document.getElementById('app')

const props = {
    threshold: el?.dataset.threshold ? el?.dataset.threshold : "",
    warningText: el?.dataset.warningText  ? el?.dataset.warningText : "",
    logoPath: el?.dataset.logoPath ? el?.dataset.logoPath: "",
    fileName: el?.dataset.fileName ? el?.dataset.fileName : "",
    errorText: el?.dataset.errorText ? el?.dataset.errorText : "",
    visiblePoints: el?.dataset.visiblePoints === 'true'
}

const app = createApp(App,props)
app.mount(el)
